import {
	LoanPeriodEnum,
	SaleTypeEnum,
} from "../../../../../../constants/Constants";

export const TecAssuredProductInputMap = {
	DLP: {},
	RS: {
		20: [
			{
				Property: "apr",
				Name: "APR %",
				DC: "deal.sale.apr",
				transform: (apr) => {
					return apr * 100;
				},
			},
			{
				Property: "loanType",
				Name: "Loan Type",
				DC: "deal.sale",
				transform: (sale) => {
					if (sale.saleType === SaleTypeEnum.LEASE.value) {
						return "LEASE";
					} else if (sale.hasBalloon) {
						return "BALLOON";
					} else {
						return "LOAN";
					}
				},
			},
		],
		21: [
			{
				Property: "dealid",
				Name: "Deal ID",
				DC: "deal.sale.dealNumber",
			},
		],
		29: [
			{
				Property: "LoanAPR",
				Name: "Loan APR",
				DC: "deal.sale.apr",
				transform: (apr) => {
					return apr * 100;
				},
			},
			{
				Property: "LoanTerm",
				Name: "Loan Term",
				DC: "deal.sale.term",
			},
			{
				Property: "New-Used",
				Name: "New-Used",
				DC: "vehicle.newUsed",
				transform: (value) => value?.toUpperCase?.(),
			},
		],
		32: [
			{
				Property: "product.xAmountFinanced",
				Name: "Amount Financed",
				DC: "deal.sale.amtFinanced",
			},
			{
				Property: "product.xAPR",
				Name: "Interest Rate (APR)",
				DC: "deal.sale.apr",
				transform: (apr) => {
					return apr * 100;
				},
			},
		],
		38: [
			{
				Property: "loanAmount",
				Name: "Loan Amount (Max $100K)",
				DC: "deal.sale.loan",
			},
			// loan / value
			// {
			//     "ProductPropertyID": "31",
			//     "ProductTypeID": "38",
			//     "ProductType": "GAP - Allied",
			//     "Property": "LTV",
			//     "Name": "LTV%",
			//     "PropertyType": "Decimal",
			//     "Required": "true",
			//     "Extension": null
			// }
		],
		42: [
			{
				Property: "dealid",
				Name: "Deal ID",
				DC: "deal.sale.dealNumber",
			},
		],
	},
	"IMA TPA": {
		4: [
			{
				Property: "GAP_APR",
				Name: "Finance APR",
				DC: "deal.sale.apr",
				transform: (apr) => {
					return apr * 100;
				},
			},
			{
				Property: "GAP_FinAgreeNum",
				Name: "Finance Agreement Num",
				DC: "deal.sale.dealNumber",
			},
			{
				Property: "GAP_FinanceAmmt",
				Name: "Financed Ammt",
				DC: "deal.sale.amtFinanced",
			},
			{
				Property: "GAP_LoanType",
				Name: "LoanType",
				DC: "deal.sale",
				transform: (sale) => {
					if (sale.hasBalloon) {
						return "BALLOON";
					} else {
						return "LOAN";
					}
				},
			},

			// dont have this
			// {
			//     "ProductPropertyID": "4",
			//     "ProductTypeID": "4",
			//     "ProductType": "GAP",
			//     "Property": "GAP_DealerAcct",
			//     "Name": "Gap Dealer Acct#",
			//     "PropertyType": "String",
			//     "Required": "false",
			//     "Extension": null
			// },

			{
				Property: "GAP_MSRP",
				Name: "MSRP",
				DC: "vehicle.msrp",
			},
			{
				Property: "GAP_N-U",
				Name: "New/Used",
				DC: "vehicle.newUsed",
				// transform: (value) => value?.toUpperCase?.(),
			},
		],
		13: [
			{
				Property: "GAP_APR",
				Name: "Finance APR",
				DC: "deal.sale.apr",
				transform: (apr) => {
					return apr * 100;
				},
			},
			{
				Property: "GAP_DownPay",
				Name: "Down Payment Amount",
				DC: "deal.sale.down",
			},
			// customer insurance?
			// {
			//     "ProductPropertyID": "12",
			//     "ProductTypeID": "13",
			//     "ProductType": "RV GAP",
			//     "Property": "GAP_InsDeduct",
			//     "Name": "Primary Insurance Deductible",
			//     "PropertyType": "Currency",
			//     "Required": "false",
			//     "Extension": null
			// },
			{
				Property: "GAP_MSRP",
				Name: "MSRP",
				DC: "vehicle.msrp",
			},
		],
		16: [
			{
				Property: "DV_APR",
				Name: "Finance APR",
				DC: "deal.sale.apr",
				transform: (apr) => {
					return apr * 100;
				},
			},
			{
				Property: "DV_Auto_Color",
				Name: "Vehicle Color",
				DC: "vehicle.color",
			},
			{
				Property: "DV_PurchaseType",
				Name: "Purchase Type",
				DC: "deal.sale",
				transform: (sale) => {
					if (sale.saleType === SaleTypeEnum.LEASE.value) {
						return "Lease";
					} else if (sale.loanPeriod === LoanPeriodEnum.COD.value) {
						return "Cash";
					} else {
						return "Loan";
					}
				},
			},
		],
	},
	HeadStart: {
		4: [
			{
				Property: "GAP_APR",
				Name: "Finance APR",
				DC: "deal.sale.apr",
				transform: (apr) => {
					return apr * 100;
				},
			},
			// i dont think we have this
			{
				ProductPropertyID: "4",
				ProductTypeID: "4",
				ProductType: "GAP",
				Property: "GAP_DealerAcct",
				Name: "Gap Dealer Acct#",
				PropertyType: "String",
				Required: "false",
				Extension: null,
			},
			{
				Property: "GAP_FinAgreeNum",
				Name: "Finance Agreement Num",
				DC: "deal.sale.dealNumber",
			},
			{
				Property: "GAP_FinanceAmnt",
				Name: "Finance Amount*",
				DC: "deal.sale.amtFinanced",
			},
			{
				Property: "GAP_FirstPaymentDueDate",
				Name: "First Payment Due Date",
				DC: "deal.sale.firstDueDate",
			},
			{
				Property: "GAP_MonthlyLoanPayment",
				Name: "Monthly Loan Payment (GAP)",
				DC: "deal.sale.payment",
			},
			{
				Property: "GAP_MSRP",
				Name: "MSRP*",
				DC: "vehicle.msrp",
			},
			// customer insurance?
			{
				ProductPropertyID: "43",
				ProductTypeID: "4",
				ProductType: "GAP",
				Property: "GAP_PrimaryDeductible",
				Name: "Primary Insurance Deductible",
				PropertyType: "Currency",
				Required: "false",
				Extension: null,
			},
			{
				Property: "LoanType",
				Name: "Loan Type",
				DC: "deal.sale",
				transform: (sale) => {
					if (sale.saleType === SaleTypeEnum.LEASE.value) {
						return "LEASE";
					} else if (sale.hasBalloon) {
						return "BALLOON";
					} else if (sale.saleType === SaleTypeEnum.RTO.value) {
						return "Other";
					} else {
						return "Installment Sales Contract";
					}
				},
			},
			{
				Property: "N-U",
				Name: "New - Used",
				DC: "vehicle.newUsed",
				// transform: (value) => value?.toUpperCase?.(),
			},
		],
	},
	"Diamond Warranty": {
		4: [
			{
				Property: "GAP_APR",
				Name: "APR%",
				DC: "deal.sale.apr",
				transform: (apr) => {
					return apr * 100;
				},
			},
			{
				Property: "GAP_FirstPaymentDueDate",
				Name: "First Payment Date",
				DC: "deal.sale.firstDueDate",
			},
			{
				Property: "GAP_MonthlyLoanPayment",
				Name: "Monthly Loan Payment",
				DC: "deal.sale.payment",
			},
			{
				Property: "LoanType",
				Name: "Loan Type",
				DC: "deal.sale",
				transform: (sale) => {
					if (sale.saleType === SaleTypeEnum.LEASE.value) {
						return "LEASE";
					} else if (sale.hasBalloon) {
						return "BALLOON";
					} else {
						return "LOAN";
					}
				},
			},
		],
	},
};
